export { default as aboutCompanyDesktopVideo } from 'videos/aboutCompanyDesktopVideo.mp4';
export { default as aboutCompanyMobileVideo } from 'videos/aboutCompanyMobileVideo.mp4';
export { default as videoContractSigner } from './videoContractSigner.mp4';
export { default as videoInstruction } from './videoInstruction.mp4';
export { default as adeptVideoLight } from 'videos/adeptVideo-light.mp4';
export { default as adeptVideoDark } from 'videos/adeptVideo-dark.mp4';
export { default as laptopWhite } from 'videos/laptop-white.mp4';
export { default as laptopBlack } from 'videos/laptop-black.mp4';
export { default as easiConnectVideo } from 'videos/easiConnectVideo.mp4';
export { default as gpmVideo } from 'videos/gpm.mp4';
